// The systems that can own a file instead of orgaMAX Web. Deliberately its own leaf module and not
// part of `modules/file/constants`: that one builds TAG_LABELS by destructuring `lang` at import
// time, so anything importing it drags the whole language file into the graph — and any test with a
// partial `jest.mock('@/lang')` then fails to run before a single test does. This value is needed
// deep inside widely imported helpers (invoice-analysis-state, desktop-owned-file), which must stay
// cheap to import. `constants.js` re-exports it, so existing importers are unaffected.
export const EXTERNAL_OWNER_SYSTEMS = Object.freeze({
  desktop: 'desktop',
})
